import { RouteConfig } from "vue-router";

export const RExpertDataHistory: RouteConfig = {
  path: "data_history/:tabTypeId(\\d+)",
  name: "ServicesDataHistory",
  component: () =>
    import(
      /* webpackChunkName: "services-data-history" */
      "./VDataHistory.vue"
    ),
  meta: {
    label: "data history",
    tabName: "employer_company_data_history",
    alias: "data_history",
  },
};
